import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Algunas semanas tienes la agenda llena… y otras a medias', 'Alumnos que cancelan a último momento', 'Estás obligado a cobrar lo mismo que todos', 'Y por más que trabajes… tus ingresos no crecen'];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-108">
          Seamos honestos…
        </h2>
        <p className="text-xl text-gray-300 mb-8 text-center" data-id="element-109">
          Ser profesor de pádel no es tan fácil como parece desde fuera.
        </p>

        <div className="space-y-4 mb-8" data-id="element-110">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-card/50 p-4 rounded-lg border border-red-500/20" data-id="element-111">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-112" />
              <p className="text-lg" data-id="element-113">{point}</p>
            </motion.div>)}
        </div>

        <p className="text-xl text-center text-gray-300 font-semibold" data-id="element-114">
          Terminas cambiando tiempo por dinero, sin una forma real de escalar.
        </p>
      </div>
    </motion.section>;
}